import dynamic from 'next/dynamic';
const EventListBlock = dynamic(() => import('./EventListBlock'));

export default EventListBlock;
